import Loadable from "react-loadable";
import Loading from "./loading";

export default Loadable({
  loading: Loading,
  loader: () => import(/* webpackChunkName: "route-graphiql"*/ "./wrapper")
});
